import { COLOR_PALETTE } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

// Active sub-tab: dark uses the accent-soft fill + primary light text (the light pale BRAND[1] fill
// would leak near-white on the dark canvas); light keeps the original BRAND tints.
const getSubTabColor = (palette, isActiveSubTab) => {
  if (!isActiveSubTab) {
    return palette.text.dark;
  }

  return palette.mode === 'dark' ? palette.text.primary : COLOR_PALETTE.BRAND[6];
};

const getActiveSubTabFill = palette =>
  palette.mode === 'dark' ? palette.primary.soft : COLOR_PALETTE.BRAND[1];

export const containerStyles = {
  overflow: 'hidden auto',
  width: '100%',
};

export const getTabStyles = ({
  isCategoryTab,
  isSubtabsExpanded,
  isActiveSubTab,
  isClickable,
  isDisabled,
}) => ({
  ...getConditionalObject(!isCategoryTab, {
    gap: '10px',
    borderRadius: '8px',
    color: ({ palette }) => `${getSubTabColor(palette, isActiveSubTab)} !important`,
    backgroundColor: ({ palette }) =>
      isActiveSubTab ? getActiveSubTabFill(palette) : 'transparent',
    padding: '12px 16px',
    position: ' relative',

    '&:hover': {
      backgroundColor: ({ palette }) =>
        isActiveSubTab ? getActiveSubTabFill(palette) : palette.background.secondary,
    },
  }),

  ...getConditionalObject(isCategoryTab, {
    padding: '16px',
    borderBottom: ({ palette }) =>
      `1px solid ${isSubtabsExpanded ? COLOR_PALETTE.BRAND[5] : palette.border.default}`,
    color: ({ palette }) =>
      `${isDisabled ? palette.text.disabled : palette.text.primary} !important`,
    gap: '8px',

    '&:hover': {
      backgroundColor: 'transparent',
    },
  }),

  textDecoration: 'none !important',
  ...(isClickable && { cursor: 'pointer' }),

  '& .MuiListItemText-root': {
    margin: 0,
  },

  '& .MuiTypography-root': {
    lineHeight: '20px',
  },
});

export const getIconStyles = ({ isBackground, isDisabled }) => ({
  width: '20px',
  height: '20px',

  ...getConditionalObject(isBackground, {
    width: '24px',
    height: '24px',
    display: 'grid',
    placeItems: 'center',
    borderRadius: '50%',
    background: isDisabled ? COLOR_PALETTE.GRAY[5] : COLOR_PALETTE.BRAND[5],
    color: ({ palette }) => palette.common.white,
  }),
});

export const getSubTabListStyles = ({ isBorder }) => ({
  padding: '8px',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  ...getConditionalObject(isBorder, {
    borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  }),
});

export const indicatorStyles = {
  position: 'absolute',
  width: '8px',
  height: '100%',
  left: 0,
  borderTopLeftRadius: '8px',
  borderBottomLeftRadius: '8px',
  borderRight: `4px solid ${COLOR_PALETTE.BRAND[1]}`,
  background: `linear-gradient(to right, ${COLOR_PALETTE.BRAND[6]} 4px, transparent 4px)`,
};

export const shortcutOverlayBadgeStyles = {
  position: 'absolute',
  top: '50%',
  right: '12px',
  transform: 'translateY(-50%)',
  height: '20px',
  padding: '0 6px',
  borderRadius: '6px',
  backgroundColor: ({ palette }) => palette.background.disabled,
  color: ({ palette }) => palette.text.dark,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pointerEvents: 'none',
  whiteSpace: 'nowrap',
};
